import { useTranslation } from 'react-i18next';
import { Loader } from '@components/ui/Loader/Loader';
import styles from './AlertSettingsList.module.css';

/** What a settings page shows until its settings arrive. */
export function AlertSettingsLoading() {
  const { t } = useTranslation();
  return (
    <div className={styles.status} role="status" aria-busy="true" aria-label={t('common.loading')}>
      <Loader />
    </div>
  );
}
